import { useState } from 'react'
import SectionLabel from './SectionLabel'
import Accordion from './Accordion'

const faqs = [
  { q: 'Do you book through an agency?', a: 'No — you book directly with a licensed local guide. No middlemen, no agency markup, and you can message your guide personally before and during the trip.' },
  { q: 'How many people are in a group?', a: 'Groups are capped at 6 people. You can also arrange a private departure for just you and your guide.' },
  { q: 'What is included in the price?', a: 'All permits, a licensed guide, teahouse accommodation, and trail meals are included. See each trek page for the full breakdown.' },
  { q: 'How do I start planning?', a: 'Message on WhatsApp with your rough dates and trek interest. We\'ll build the itinerary together from there — no obligation to book.' },
]

export default function HomeFAQ() {
  const [expandAll, setExpandAll] = useState(false)

  return (
    <section className="section bg-stone">
      <div style={{
        maxWidth: '720px', margin: '0 auto', background: 'var(--white)',
        border: '1px solid var(--stone-mid)', borderRadius: 'var(--radius-lg)', padding: '40px',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '24px' }}>
          <div>
            <SectionLabel>FAQ</SectionLabel>
            <h2 className="section-title" style={{ marginBottom: 0 }}>Common questions.</h2>
          </div>
          <button
            onClick={() => setExpandAll(e => !e)}
            className="btn"
            style={{ background: 'transparent', border: '1px solid var(--stone-mid)', color: 'var(--ink-mid)', fontSize: '12px' }}
          >
            {expandAll ? 'Collapse all' : 'Expand all'}
          </button>
        </div>

        <Accordion items={faqs} exclusive={false} openAll={expandAll} defaultOpenIndex={0} />
      </div>
    </section>
  )
}
